import React from 'react';
import './spinner.css'

const Spinner = () => {
  return (
    <div className="loadingio-spinner-ripple-tiol49iw8o">
      <div className="ldio-1yzaoj1eeam">
        <div></div>
        <div></div>
      </div>
    </div>
  );
}

export default Spinner;
